/** The element id of the checklist card on Home (`FirstReleaseChecklist`). */
export const FIRST_RELEASE_CHECKLIST_ID = 'first-release-checklist';

// About one second at 60 frames a second: Home may still load when the row is clicked.
const MAX_FRAMES = 60;

/**
 * design: navigation-v2 6c. Scrolls Home to the checklist card and moves the focus to it. The
 * sidebar row calls it right after it opens Home, so it waits until the card is on the page.
 */
export function scrollToFirstReleaseChecklist(frame = 0): void {
  if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
    return;
  }
  window.requestAnimationFrame(() => {
    const card = document.getElementById(FIRST_RELEASE_CHECKLIST_ID);
    if (card === null) {
      if (frame < MAX_FRAMES) {
        scrollToFirstReleaseChecklist(frame + 1);
      }
      return;
    }
    if (typeof card.scrollIntoView === 'function') {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    card.focus({ preventScroll: true });
  });
}
